/* ==========================================================================================
   Commercial Equipment Online 2026 · ce-card-quote.js · "Add to quote" on the product cards of the collection and
   search grids (snippets/ce-product-card.liquid with show_quote: true). Tommy 10-10: "on collection pages should be
   add to cart and add to quote button, same as existing website". Deferred, no dependencies, safe to load twice.

   HOW (the product page's own way, assets/ce-product-page.js part 6): OUR button presses the O: Request a Quote
   app's OWN card button, so everything after the press is the app's: its window (Step 1: the product and a quantity;
   its "Add To Quote" puts the product in the quote and moves on to Step 2, contact details), its quote list, its
   "View Quote (N)" tab, and so the header's Quote count (assets/ce-header.js reads the app's own count).
   The app draws a card button only into a card it recognises: such a card carries .product-card (a card class from
   the app's own list) and an empty .productitem--action (where the store's app settings put a card's button: the old
   theme's class), both printed by the card. The app looks every 2 s (its first look comes about 4 s after the page
   starts), asks Shopify for the product, then draws its button there, unseen (ce-base.css 18, .ce-card__appq).

   WHICH CARDS: the app's own rule. While it offers a quote for EVERY product on collection pages (its "all products"
   setting, 10-10), our button shows at once, and a press before the app has drawn its button waits for it (the button
   turns, up to 10 s). With a narrower rule our button waits, its space kept, until the app has drawn its own button
   in that card. Ours leaves the card when the app has looked at the card and drawn nothing for 8 s, when the app's
   button is disabled, when the app's settings switch card buttons off, or when the app is not on the page at all.
   ========================================================================================== */
(() => {
  'use strict';
  if (window.CECardQuote) return;
  const W = window, D = document;
  const OURS = '[data-ce-card-quote]';
  const T0 = Date.now();

  // the app's own button in this card (drawn by the app into the card's .ce-card__appq)
  const appBtn = (card) => card.querySelector('.ce-card__appq button.omgrfq-btn-quotes') || card.querySelector('.ce-card__appq button');
  // the app's card-button rule: true = every product, for every visitor; false = narrower or off; null = not known
  const rule = () => {
    const c = W.OMGRFQConfigs;
    const b = c && c.appQuotesSettings && c.appQuotesSettings.button_setting;
    if (!b) return null;
    if (Number(b.show_on_collection) !== 1) return 'off';
    return b.type_condition === 'all' && !Number(b.applied_customers_mode) ? 'all' : 'some';
  };

  // on = shown; wait = its space kept, not shown; off = gone
  const set = (ours, state) => {
    if (ours.ceState === state) return;
    ours.ceState = state;
    ours.hidden = state === 'off';
    ours.classList.toggle('is-wait', state === 'wait');
    if (state === 'wait') ours.setAttribute('aria-hidden', 'true'); else ours.removeAttribute('aria-hidden');
  };

  // 14-10-2026: Quotes AI. Its script marks <html class="qai-cards"> while its card hook is live and the merchant's
  // switch is on; then OUR button is simply shown and the press is the app's (data-qai-add-handle on the button:
  // it asks Shopify for the product, puts it in the quote, says "Added to your quote" and fires qai:added on the
  // button). Everything about Omega below stays for as long as Omega is the app on the page.
  const qai = () => D.documentElement.classList.contains('qai-cards');

  const look = () => {
    const r = rule();
    const noApp = !W.OMGRFQConfigs && Date.now() - T0 > 6000;
    D.querySelectorAll(OURS).forEach((ours) => {
      const card = ours.closest('[data-ce-card]');
      if (!card) return;
      if (qai()) { set(ours, 'on'); return; }
      if (noApp || r === 'off') { set(ours, 'off'); return; }
      const real = appBtn(card);
      if (real) {
        real.tabIndex = -1;                       // never a second, unseen stop for the Tab key
        set(ours, real.disabled ? 'off' : 'on');
        return;
      }
      // the app has looked at this card (it marks the card's link) but drew nothing: no quote for this product
      const link = card.querySelector('.ce-card__link');
      if (link && link.classList.contains('omgrfq-product-link--processed')) {
        if (!ours.ceLooked) ours.ceLooked = Date.now();
        if (Date.now() - ours.ceLooked > 8000) { set(ours, 'off'); return; }
      }
      set(ours, r === 'some' ? 'wait' : 'on');
    });
  };

  // a press: hand it to the app's own button (re-found now: the app redraws its buttons)
  const press = (ours) => {
    const card = ours.closest('[data-ce-card]');
    if (!card || ours.ceBusy) return;
    const go = (real) => {
      ours.ceBusy = true;
      ours.classList.add('is-loading');
      ours.setAttribute('aria-busy', 'true');
      real.click();
      // the app turns its own button while it opens its window: ours turns with it (at most 6 s)
      const t = Date.now();
      const done = () => {
        if (real.classList.contains('omgrfq-btn-loading') && Date.now() - t < 6000) { setTimeout(done, 120); return; }
        ours.ceBusy = false;
        ours.classList.remove('is-loading');
        ours.removeAttribute('aria-busy');
      };
      setTimeout(done, 350);
    };
    const real = appBtn(card);
    if (real && !real.disabled) { go(real); return; }
    // pressed before the app has drawn its button (the first ~5 s of a page): wait for it, turning, up to 10 s
    ours.ceBusy = true;
    ours.classList.add('is-loading');
    ours.setAttribute('aria-busy', 'true');
    const t = Date.now();
    const wait = () => {
      const r = appBtn(card);
      if (r && !r.disabled) { ours.ceBusy = false; go(r); return; }
      if (Date.now() - t < 10000) { setTimeout(wait, 150); return; }
      ours.ceBusy = false;
      ours.classList.remove('is-loading');
      ours.removeAttribute('aria-busy');
      look();
    };
    wait();
  };

  D.addEventListener('click', (e) => {
    const ours = e.target.closest && e.target.closest(OURS);
    if (!ours) return;
    if (qai() && ours.hasAttribute('data-qai-add-handle')) {
      // the app's own listener takes this press; ours only turns until the app answers (at most 8 s)
      if (ours.ceBusy) { e.preventDefault(); return; }
      ours.ceBusy = true;
      ours.classList.add('is-loading');
      ours.setAttribute('aria-busy', 'true');
      ours.ceT = setTimeout(() => { ours.ceBusy = false; ours.classList.remove('is-loading'); ours.removeAttribute('aria-busy'); }, 8000);
      return;
    }
    e.preventDefault();
    press(ours);
  });
  const settle = (e) => {
    const ours = e.target && e.target.closest && e.target.closest(OURS);
    if (!ours) return;
    clearTimeout(ours.ceT);
    ours.ceBusy = false;
    ours.classList.remove('is-loading');
    ours.removeAttribute('aria-busy');
    if (e.type === 'qai:added') {
      ours.classList.add('is-added');
      clearTimeout(ours.ceA);
      ours.ceA = setTimeout(() => ours.classList.remove('is-added'), 2600);
    }
  };
  D.addEventListener('qai:added', settle);
  D.addEventListener('qai:add-failed', settle);

  // look now, then often while the app starts (first 30 s), then every 3 s; at once when cards arrive (a filter, a
  // sort or a new page swaps the grid in place)
  look();
  let n = 0;
  const fast = setInterval(() => { look(); if (++n >= 30) { clearInterval(fast); setInterval(() => { if (!D.hidden) look(); }, 3000); } }, 1000);
  let queued = false;
  const soon = () => { if (queued) return; queued = true; requestAnimationFrame(() => { queued = false; look(); }); };
  if ('MutationObserver' in W) {
    new MutationObserver((list) => {
      for (const m of list) {
        for (const node of m.addedNodes) {
          if (node.nodeType === 1 && (node.matches(OURS) || node.querySelector(OURS) || node.closest('.ce-card__appq'))) { soon(); return; }
        }
      }
    }).observe(D.body, { childList: true, subtree: true });
  }
  W.CECardQuote = { look };
})();
